import { Component, OnInit } from '@angular/core';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { INotification } from 'src/app/Models/Notification';
import { ModalService } from 'src/app/Services/confirmation-modal/modalServie.service';
import { NotificationService } from 'src/app/Services/notifications/notifications.service';
import { SessionService } from 'src/app/Services/session.service';
import { NotificationAddEditComponent } from '../notification-add-edit/notification-add-edit.component';

@Component({
  selector: 'app-notification',
  templateUrl: './notification.component.html',
  styleUrls: ['./notification.component.css'],
})
export class NotificationComponent implements OnInit {
  notifications:INotification[]= [];
  constructor(
    private notifcationService:NotificationService,
    public session: SessionService,
    private modalService: NgbModal,
    private modalServiceLocal: ModalService,
  ) { }

  ngOnInit(): void {
    this.getNotifications();
  }

  getNotifications(){
    this.notifcationService.GetNotifications({
      LoggedInUser:  this.session.getUser(),
      NotificationID: null,
      NotificationMaterialId: null,
      NotificationAffectedAreaTypeCode: null,
      NotificationMethodTypeCode: null,
      NotificationSeverityTypeCode: null,
      NotificationAcknowledgementTypeCode: null,
      NotifiedMaterialStatusTypeCode: null,
      NotificationReleaseDate: null,
      NotificationWithdrawnDate: null,
      ReleasedInd: 'N',
      DeletedInd: 'N',
      ScreenName : null,
      CreationDate: null,
      UpdationDate : null
    }).subscribe((res)=>{
      console.log(res);
      this.notifications = res;
    })
  }

  openNotification(){

  }
CreateUpdateNotification(notification: INotification | null) {
  const modalRef = this.modalService.open(NotificationAddEditComponent, {
    centered: true,
    size: 'xl',
    windowClass: 'custom-modal-width-notification-course',
    backdropClass: 'custom-backdrop-notification'
  });

  modalRef.componentInstance.screenName = notification?.Notification_Affected_Area_Type_Code ?? null;
  modalRef.componentInstance.MaterialId = notification?.Notification_Material_Id ?? null;
  modalRef.componentInstance.notification = notification;

  // 🔹 Get result from modal (close/dismiss)
  modalRef.result
    .then((result) => {
      if (result) {
        console.log('Modal closed with result:', result);

        this.getNotifications();
      }
    })
    .catch((reason) => {

    });
}


}
